const BaseController = require('base/controller/loadDataController'),
    PasswordResetModel = require('./passwordResetModel'),
    PasswordResetView = require('./passwordResetView');

const Controller = BaseController.extend({
    data: function (resetKey) {
        return {
            passwordResetModel: new PasswordResetModel({ resetKey: resetKey })
        };
    },
    unauthorized: true,
    render: function(returnPath) {
        this.data.passwordResetModel.applyPasswordPolicy();
        let view = new PasswordResetView({ model: this.data.passwordResetModel });
        return view;
    }
});

module.exports = new Controller();
